import React from 'react';

import {AlertInfo} from 'presentation/components/AlertInfo';
import {translations} from 'presentation/translations-new';
import {useHostName} from 'presentation/hooks';

const {alertInfo} = translations['pt-br'].publicFlow.signUp;

export function Alert() {
	const {
		dataHostNameState: {product},
	} = useHostName();

	return (
		<AlertInfo.Root>
			<AlertInfo.Description>{alertInfo[product]}</AlertInfo.Description>
		</AlertInfo.Root>
	);
}
